module.exports = __webpack_public_path__ + "img/avatar3.e14f87c7.png";